"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShippingOffer = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _FormattedMessage = require("../FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  background: theme.palette.offer.light,
  padding: theme.spacing(2, 2, 2, 3),
  marginTop: theme.spacing(2),
  color: theme.palette.offer.main,
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  fontWeight: 'bold',
  borderRadius: theme.spacing(2),
  boxSizing: 'border-box',
  cursor: 'pointer',
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(2, 3, 2, 4)
  }
}));
const DiscountTag = (0, _mui.styled)(_icons.DiscountTagFilled)(({
  theme
}) => ({
  color: theme.palette.offer.main,
  marginRight: theme.spacing(3)
}));
const Arrow = (0, _mui.styled)(_icons.ArrowRightThin)(({
  theme
}) => ({
  color: theme.palette.offer.main,
  marginLeft: 'auto'
}));
const ShippingOffer = props => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const usedProps = {
    ...getTestIdProps(_models.TestId.ShippingOffer),
    ...props
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    ...usedProps,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(DiscountTag, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
      id: "buyProductAndGetFreeDelivery"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Arrow, {})]
  });
};
exports.ShippingOffer = ShippingOffer;